import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'

import { LocalStorage } from 'lib/storage'
import { Post } from 'lib/_types'

const initialState: {
  filters: {
    hideHotPost: boolean
    sharedInterests: boolean
  }
  preloadedPosts: {
    fromId: string
    posts: Array<Post>
    hotPosts: Array<Post>
    recommendedPosts: Array<Post>
    fromIdRecommended: string
    isAlreadySeeMoreHotPost: boolean
    type: 'following' | 'noReply' | 'public'
  }
} = {
  filters: LocalStorage.timelineFilters.get({
    hideHotPost: false,
    sharedInterests: false,
  }),
  preloadedPosts: undefined,
}

export const timelineSlice = createSlice({
  name: 'timeline',
  initialState,
  reducers: {
    setFilters: (
      state,
      action: PayloadAction<typeof initialState['filters']>
    ) => {
      state.filters = action.payload
      LocalStorage.timelineFilters.set(state.filters)
    },
    clearPreloadedPosts: (state) => {
      state.preloadedPosts = undefined
    },
    setPreloadedPosts: (
      state,
      action: PayloadAction<typeof initialState['preloadedPosts']>
    ) => {
      state.preloadedPosts = action.payload
    },
  },
})

export const selectTimeline = (state: any): typeof initialState =>
  state.timeline
export const selectTimelineFilters = createSelector(
  selectTimeline,
  (timeline) => timeline.filters
)
export const selectTimelinePosts = createSelector(
  selectTimeline,
  (timeline) => timeline.preloadedPosts
)

export const { setFilters, clearPreloadedPosts, setPreloadedPosts } =
  timelineSlice.actions

export default timelineSlice.reducer
